// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 30px;

  /* width: 709px;
  height: 122px; */
  max-width: 650px;

  /* background-color: white; */
}

.work-left {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 37px 10px;
  gap: 10px;

  /* width: 87px;
  height: 122px; */
  min-width: 60px;
  height: 100%;

  background: #6b3cb9;
}

.work-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px 0px;
  gap: 20px;

  /* width: 592px;
  height: 122px; */
}

.work-header {
  /* width: 275px;
  height: 25px; */

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 25px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #000000;
}

.work-copy {
  /* width: 592px; */
  /* height: 40px; */

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;

  color: #8d8d8d;
}

@media (max-width: 415px) {
 .work-container{
  gap: 20px;
 } 

 .work-content{
  gap: 0.5rem;
 }

}`, "",{"version":3,"sources":["webpack://./src/assets/WorkTile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;;EAET;kBACgB;EAChB,gBAAgB;;EAEhB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;;EAET;kBACgB;EAChB,eAAe;EACf,YAAY;;EAEZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;;EAET;kBACgB;AAClB;;AAEA;EACE;iBACe;;EAEf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,aAAa;EACb,mBAAmB;;EAEnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;;EAElB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;;EAEnB,cAAc;AAChB;;AAEA;CACC;EACC,SAAS;CACV;;CAEA;EACC,WAAW;CACZ;;AAED","sourcesContent":[".work-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n  gap: 30px;\n\n  /* width: 709px;\n  height: 122px; */\n  max-width: 650px;\n\n  /* background-color: white; */\n}\n\n.work-left {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 37px 10px;\n  gap: 10px;\n\n  /* width: 87px;\n  height: 122px; */\n  min-width: 60px;\n  height: 100%;\n\n  background: #6b3cb9;\n}\n\n.work-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 15px 0px;\n  gap: 20px;\n\n  /* width: 592px;\n  height: 122px; */\n}\n\n.work-header {\n  /* width: 275px;\n  height: 25px; */\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 25px;\n  /* identical to box height */\n\n  display: flex;\n  align-items: center;\n\n  color: #000000;\n}\n\n.work-copy {\n  /* width: 592px; */\n  /* height: 40px; */\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n\n  color: #8d8d8d;\n}\n\n@media (max-width: 415px) {\n .work-container{\n  gap: 20px;\n } \n\n .work-content{\n  gap: 0.5rem;\n }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
